import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 18 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 24\" id=\"icon-upload\"><g transform=\"translate(-1207 -915)\"><path d=\"M16,11h5L12,21,3,11H8V0h8Z\" transform=\"translate(1228 936) rotate(180)\" fill=\"currentColor\" /><rect width=\"10\" height=\"2\" transform=\"translate(1211 937)\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol